module.exports = __webpack_public_path__ + "static/img/house.5d95c670.png";